<template>
    <div class="autocomplete" id="parent">
        <input
        v-if="selectable==false"
        v-bind:id="'auto'+index"
        autocomplete="off"
        :tabindex="-1"
        type="text"
        @input="onChange"
        v-model="content"
        :style="'width:'+width"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        @keydown.tab="onEnter"
        @keydown.escape="clear"
        />
        <input
        v-else
        v-bind:id="'auto'+index"
        autocomplete="off"
        type="text"
        @input="onChange"
        v-model="content"
        :style="'width:'+width"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        @keydown.tab="onEnter"
        @keydown.escape="clear"
        />
        <ul
        :tabindex=-1
        id="autocomplete-results"
        v-show="isOpen"
        class="autocomplete-results"
        :style="{ position: fixed == true ? 'fixed' : 'absolute' }"
        >
            <li
            class="loading"
            v-if="isLoading"
            :tabindex=-1
            >
                Loading results...
            </li>
            <li
            v-else
            v-for="(result, i) in results"
            :tabindex=-1
            :key="i"
            @click="setResult(i)"
            class="autocomplete-result"
            :class="{ 'is-active': i === arrowCounter }">
                {{ result }}
            </li>
        </ul>
    </div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    name: 'autocomplete',
    props: {
        index: Number,
        value: null,
        type: Number,
        selectable: {
            type: Boolean,
            required: false,
            default: true
        },
        list: {
            type: Array,
            required: false,
            default: null
        },
        isAsync: {
            type: Boolean,
            required: false,
            default: false
        },
        width: {
            type: String,
            required: false,
            default: "100%"
        },
        do_first_send: {
            type: Boolean,
            required: false,
            default: true
        },
        fixed: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            content: this.value,
            isOpen: false,
            results: [],
            isLoading: false,
            arrowCounter: 0,
            fullResults: [],
            fullContent: [],
            lastUpdate: 0,
        };
    },
    methods: {
        onChange() {
            this.sendData();

            if (this.isAsync) {
                this.isLoading = true;
            } else {
                this.filterResults();
                this.isOpen = true;
            }
        },
        filterResults() {
            if(this.list!=null) {
                this.results = this.list;
            }else {
                this.isLoading=true;

                let timestamp = new Date().getTime()

                api.postData(
                    {
                        type:"suggestion",
                        data:{
                            index:this.type,
                            data:[this.content]
                        },
                        timestamp:timestamp,
                    }
                ).then((res) => {
                    if(res.data.timestamp > this.lastUpdate){
                        this.lastUpdate = res.data.timestamp
                        this.results = [];
                        this.isLoading=false;
                        for(var i=0;i<res.data.data.column_data.length;i++){
                            this.results.push(res.data.data.column_data[i][0]);
                        }

                        this.fullResults = res.data.data.column_data;
                    }
                });
            }
        },
        setResult(result) {
            this.content = this.results[result];
            this.fullContent = this.fullResults[result];
            this.close();
        },
        onArrowDown(evt) {
            if (this.arrowCounter < this.results.length-1) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },
        onArrowUp() {
            if (this.arrowCounter >= 0) {
                this.arrowCounter = this.arrowCounter -1;
            }
        },
        onEnter() {
            if(this.isOpen){
                if(this.arrowCounter!=-1){
                    this.content = this.results[this.arrowCounter];
                    this.fullContent = this.fullResults[this.arrowCounter];
                }
                this.close();
            }
        },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                this.onEnter();
            }
        },
        close() {
            if(this.arrowCounter==-1){
                this.content='';
                this.fullContent=[];
            }

            this.isOpen = false;
            this.arrowCounter = 0;

            this.$emit('finish', this.index, this.content);
            this.$emit('full', this.index, this.fullContent);
            this.sendData();
        },
        clear(){
            this.arrowCounter=-1;
            this.close();
        },
        sendData(){
            this.$emit('input', this.content)
        },
    },
    watch: {
        items: function (val, oldValue) {
            if (val.length !== oldValue.length) {
                this.results = val;
                this.isLoading = false;
            }
        },
        value: function() {
            this.content = this.value;
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside)
        this.$nextTick(function () {
            if(this.index==0){
                document.getElementById("auto"+this.index).focus();
            }
            if(this.do_first_send) {
                this.sendData();
            }
        })
    },
    destroyed() {
        document.removeEventListener('click', this.handleClickOutside)
    }
};
</script>


<style scoped>
.autocomplete {
    position: relative;
}

.autocomplete-results {
    background: #eeeeee;
    padding: 0;
    margin: 0;
    border: 1px solid #cccccc;
    border-radius: 3px;
    height: 300px;
    overflow: auto;
    width: 100%;
    z-index: 3;
}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
}

.autocomplete-result:hover {
    background-color: #dddddd;
}

.autocomplete-result.is-active {
    background-color: #35495E;
    color: white;
}

</style>



// WEBPACK FOOTER //
// src/layouts/autocomplete.vue